(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/components/receipt.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/components/receipt.js');
"use strict";


const mapReceiptData = wager => {
  var _wager$properties;
  return {
    type: 'scratchgames',
    state: 'finished',
    title: wager.description,
    payDate: new Date(wager.regWagerTime),
    finalizedDate: new Date(wager.completedOn),
    amountTotal: wager.betAmount,
    channel: 'Internet',
    amountWin: wager.winText || wager.winAmount,
    wagerId: wager.wagerId,
    productCode: wager === null || wager === void 0 || (_wager$properties = wager.properties) === null || _wager$properties === void 0 ? void 0 : _wager$properties.externalProductCode,
    isWinText: Boolean(wager.winText)
  };
};
setGlobal('svs.kenoXpress.react.components.Receipt', _ref => {
  let {
    wager,
    style = {}
  } = _ref;
  if (!wager) {
    return null;
  }
  const receiptData = mapReceiptData(wager);
  const receiptHTML = svs.tb_ui.receipt.partials.receipt(receiptData);
  return React.createElement("div", {
    className: "keno-xpress-receipt",
    style: style
  }, React.createElement("div", {
    className: "keno-xpress-receipt-table margin-2",
    dangerouslySetInnerHTML: {
      __html: receiptHTML
    }
  }), " ");
});

 })(window);